import CustomButton from 'components/Buttons/CustomButton'
import { Info } from 'react-feather'
import { useIntl } from 'react-intl'
import { Card, CardBody, CardText } from 'reactstrap'

const ItemsDetail = ({ itemDetail, totalAmount, detail }) => {
  const intl = useIntl()

  const showAdjustment =
    detail?.orderDetail?.type === 'BUY' &&
    detail?.approvedAt &&
    detail?.adjustment &&
    (detail?.orderStatus === 'DISPUTE' ||
      (detail?.orderStatus === 'ON_GOING' &&
        detail?.adjustment?.status === 'APPROVED') ||
      (detail?.orderStatus === 'RELEASED_BY_BUYER' &&
        detail?.adjustment?.status === 'APPROVED'))

  return (
    <div className="w-100">
      <Card className="w-100 mb-3">
        <CardBody>
          <CardText tag="h6" className="mb-1 fw-bold">
            Rincian Pesanan
          </CardText>
          {showAdjustment &&
            detail?.adjustment?.adjustmentitems?.length > 0 && (
              <small
                style={{ fontSize: '11px' }}
                className="fw-semibold text-danger"
              >
                <Info size={12} /> Harga dan jumlah bertanda merah menunjukkan
                nilai setelah penyesuaian
              </small>
            )}
          {itemDetail?.map((item, idx) => {
            const adjustmentItem = detail?.adjustment?.adjustmentitems?.find(
              (adj) => adj?.orderitem?.inventoryId === item?.inventoryId,
            )
            return (
              <div
                key={idx}
                data-testid={`order-item-row-${item?.inventoryId ?? idx}`}
                className="d-flex align-items-center justify-content-between gap-2 my-3"
              >
                <div>
                  <div>{item?.nameItem}</div>
                  <div className="fw-semibold">
                    <span>
                      {intl.formatNumber(item?.amount ?? 0, {
                        useGrouping: 'always',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}{' '}
                      {item?.unit ?? 'Kg'} •{' '}
                    </span>
                    <span>
                      Rp
                      {intl.formatNumber(item?.price ?? 0, {
                        useGrouping: 'always',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                  {showAdjustment && adjustmentItem && (
                    <div className="text-danger">
                      (
                      <span>
                        {intl.formatNumber(adjustmentItem?.newAmount ?? 0, {
                          useGrouping: 'always',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })}{' '}
                        {adjustmentItem?.orderitem?.unit ?? 'Kg'} •{' '}
                      </span>
                      <span>
                        Rp
                        {intl.formatNumber(adjustmentItem?.newPrice ?? 0, {
                          useGrouping: 'always',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })}
                        )
                      </span>
                    </div>
                  )}
                </div>
                <div className="d-flex flex-column align-items-end">
                  <div className="fw-semibold">
                    Rp
                    {intl.formatNumber(
                      item?.totalPrice ?? item?.price * item?.amount ?? 0,
                      {
                        useGrouping: 'always',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      },
                    )}
                  </div>
                  {showAdjustment && adjustmentItem && (
                    <div className="text-danger">
                      (Rp
                      {intl.formatNumber(
                        adjustmentItem?.newTotalPrice ??
                          adjustmentItem?.newPrice *
                            adjustmentItem?.newAmount ??
                          0,
                        {
                          useGrouping: 'always',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        },
                      )}
                      )
                    </div>
                  )}
                </div>
              </div>
            )
          })}
          <hr />
          <div
            data-testid="order-total-amount"
            className="d-flex align-items-center justify-content-between"
          >
            <span className="fw-bold">Total</span>
            <div className="d-flex flex-column align-items-end">
              <div className="fw-bold">
                Rp
                {intl.formatNumber(totalAmount ?? 0, {
                  useGrouping: 'always',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                })}
              </div>
              {showAdjustment && detail?.adjustment?.newAmount && (
                <div className=" text-danger">
                  (Rp
                  {intl.formatNumber(detail?.adjustment?.newAmount ?? 0, {
                    useGrouping: 'always',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}
                  )
                </div>
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  )
}

export default ItemsDetail
